import React, { useState, useEffect } from 'react';
import { Container, Row, Col, Card, Table, Button, Badge, Dropdown, Spinner } from 'react-bootstrap';
import { Link, useParams } from 'react-router-dom';
import { withNamespaces } from 'react-i18next';
import Utility from '../../../../GlobalModules/Utility/Utility';
import { toast } from "react-toastify";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowLeft, faEdit } from "@fortawesome/free-solid-svg-icons";
import { getMonthlyTargetDetails } from "../Controller/MonthlyTargetController";
import { getAccountDetails } from "../Controller/AccountController";
import { connect } from "react-redux";

const AccountView = (props) => {
  const { t, i18n } = props;
  const lng = i18n.language;
  const { slack } = useParams();
  const [account, setAccount] = useState(null);

  // Fetch account data based on ID
  useEffect(() => {
    const fetchAccount = async () => {
      try {
        const response = await getAccountDetails(slack);
        if (response.success && response.data) {
          setAccount(response.data);
        } else {
          toast.error(t('accountView.accountNotFound'));
        }
      } catch (error) {
        console.error('Error fetching account:', error);
        toast.error(t('accountView.fetchError'));
      }
    };

    fetchAccount();
  }, [slack]);

  if (!account) {
    return (
      <Container fluid className="p-0">
        <div className="text-center py-5">
          <p>{t('accountView.loadingDetails')}</p>
        </div>
      </Container>
    );
  }

  //======= add action permission ====//
  // Check multiple permissions at once
  const accountsViewPermissions = Utility.hasMultipleActionPermissions(
    'business_account',
    'accounts',
    ['view', 'create', 'edit', 'delete', 'export', 'approve', 'receive', 'generate_invoice', 'change_status', 'accept', 'reject', 'KOT info', 'cancel', 'bill', 'bill_post', 'cancel_bill_post', 'invoice'],
    props.userCredentials.user_details.user_type
  );

  return (
    <Container fluid className="p-0">
      <Row className="mb-3">
        <Col>
        </Col>
        <Col xs="auto" className="d-flex align-items-center">
          <Link to={`/${lng}/business/accounts`} className="btn btn-outline-secondary me-2">
            <FontAwesomeIcon icon={faArrowLeft} className="me-2" />
            {t('accountView.backToList')}
          </Link>
          
          {accountsViewPermissions.edit && (
            <Link to={`/${lng}/business/accounts/edit/${account.slack}`} className="btn btn-primary">
              <FontAwesomeIcon icon={faEdit} className="me-2" />
              {t('accountView.edit')}
            </Link>
          )}
        </Col>
      </Row>

      <Row>
        <Col lg={12} className="mb-4">
          <Card className="custom-border-light h-100">
            <Card.Body>
              <Row className={'mb-4'}>
                <Col md={11}>
                  <h2 className="text-title">{t('accountView.account')} <b>{account.label} ({account.account_code})</b></h2>
                </Col>
                <Col md={1}>
                  <Badge
                    bg={account?.status_data?.value === "1" ? 'success' : 'secondary'}
                    style={{ cursor: 'pointer' }}
                  >
                    {account?.status_data?.label || t('accountView.inactive')}
                  </Badge>
                </Col>
              </Row>

              <h2 className="text-headline mb-4">{t('accountView.basicInformation')}</h2>

              <Row className={'mb-4'}>
                <Col md={3}>
                  <p className="mb-2 fw-medium">{t('accountView.accountCode')}</p>
                  <p className="text-muted mb-0">{account.account_code}</p>
                </Col>
                <Col md={3}>
                  <p className="mb-2 fw-medium">{t('accountView.accountName')}</p>
                  <p className="text-muted mb-0">{account.label}</p>
                </Col>
                <Col md={3}>
                  <p className="mb-2 fw-medium">{t('accountView.accountType')}</p>
                  <p className="text-muted mb-0">{account.account_type_data.label}</p>
                </Col>
                <Col md={3}>
                  <p className="mb-2 fw-medium">{t('accountView.initialBalance')}</p>
                  <p className="text-muted mb-0">{account.initial_balance
                  }</p>
                </Col>
              </Row>

              <Row className={'mb-4'}>
                <Col md={3}>
                  <p className="mb-2 fw-medium">{t('accountView.posDefaultAccount')}</p>
                  <p className="text-muted mb-0">{account.pos_default === 1 ? t('accountView.yes') : t('accountView.no')}</p>
                </Col>
                <Col md={3}>
                  <p className="mb-2 fw-medium">{t('accountView.createdBy')}</p>
                  <p className="text-muted mb-0">{account.CreatedUser.first_name} {account.CreatedUser.last_name}</p>
                </Col>
                <Col md={3}>
                  <p className="mb-2 fw-medium">{t('accountView.updatedBy')}</p>
                  {/* <p className="text-muted mb-0">{account.UpdatedUser.first_name} {account.UpdatedUser.last_name}</p> */}
                  <p className="text-muted mb-0">{account.UpdatedUser ? `${account.UpdatedUser.first_name} ${account.UpdatedUser.last_name}` : ''}</p>
                </Col>
                <Col md={3}>
                  <p className="mb-2 fw-medium">{t('accountView.createdOn')}</p>
                  <p className="text-muted mb-0">{Utility.get12HourFormat(account.createdAt) || '-'}</p>
                </Col>
              </Row>

              <Row className={'mb-4'}>
                <p className="mb-2 fw-medium">{t('accountView.updatedOn')}</p>
                <p className="text-muted mb-0">{Utility.get12HourFormat(account.updatedAt) || '-'}</p>
              </Row>

              <Row className={'mb-4'}>
                <p className="mb-2 fw-medium">{t('accountView.description')}</p>
                <p className="text-muted mb-0">{account.description || '-'}</p>
              </Row>
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </Container>
  );
};

const mapStateToProps = (globalState) => ({
    userCredentials: globalState.LoginReducer.userCredentials,
    token: globalState.LoginReducer.token,
    userEntryType: globalState.LoginReducer.userEntryType
});

export default connect(mapStateToProps)(withNamespaces()(AccountView));